export enum ChangelogApplication {
  RESSIFNET = "Ressifnet",
  DAISY = "Daisy",
  MYRESSIF = "Myressif"
}